import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Header } from '../../components/Header';
import { Load } from '../../components/Load';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import { Options, Select } from '../../components/Select';
import InputMask from 'react-input-mask';
import AlertMessage from '../../components/Alert';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import api from '../../services/api';
import './style.css';
import { useParams } from 'react-router-dom';
import MultiCheckBox, { OptionType, OnSelectFunction } from '../../components/MultiCheckBox';


export function ProdutosEditar() {
    const { idProduto } = useParams();

    const [isLoading, setIsLoading] = useState(true);

    {/* Informações Gerais */ }
    const [nome, setNome] = useState("");
    const [descricao, setDescricao] = useState("");
    const [preco, setPreco] = useState('');
    const [duracao, setDuracao]: any = useState();
    const [itens, setItens] = useState<OptionType[]>([]);
    const [selectedItens, setSelectedItens] = useState<string[]>([]);
    const [tipoProduto, setTipoProduto] = useState('');

    {/* Informações de Funções */ }
    const [quantidadeFuncao, setQuantidadeFuncao] = useState(0);
    const [profissionalSelecionado, setProfissionalSelecionado] = useState(1);
    console.log("🚀 ~ ProdutosEditar ~ profissionalSelecionado:", profissionalSelecionado)
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const tipoProfissional = [
        {
            id: 1,
            nome: 'Trabalhador'
        },
        {
            id: 2,
            nome: 'Empresa'
        }
    ]

    const duracaoPlano = [
        { id: 96, nome: '96 Horas' },
        { id: 72, nome: '72 Horas' },
        { id: 48, nome: '48 Horas' },
        { id: 24, nome: '24 Horas' }
    ];

    useEffect(() => {
        const buscarDadosProduto = async () => {
            if (idProduto) {
                try {
                    const response = await api.get(`/produtos/listar/${idProduto}`);
                    const produto = response.data;

                    setNome(produto.nome);
                    setDescricao(produto.descricao);
                    setPreco(produto.preco);
                    setDuracao(produto.duracao);
                    setQuantidadeFuncao(produto.quantidade);
                    setProfissionalSelecionado(produto.tipo_produto);
                    setTipoProduto(produto.tipo);

                    const produtosItens: string[] = [];

                    produto.produtos_itens.map((item: any) => {
                        produtosItens.push(item.id.toString());
                    });

                    handleSelect(produtosItens);

                    // setSelectedItens(produtosItens);

                } catch (error) {
                    console.error('Erro ao buscar dados da empresa', error);
                }
            }
        };

        buscarDadosProduto();
    }, [idProduto]);

    useEffect(() => {
        const buscarItens = async () => {

            try {
                const response = await api.get(`itens/listar`);
                const itensData = response.data;
                const options: OptionType[] = [];

                itensData.map((item: any) => {
                    options.push({ value: item.id, name: item.nome, color: 'blue' });
                })

                setItens(options);
            } catch (error) {
                console.error('Erro ao buscar itens', error);
            }
        };

        buscarItens();
    }, []);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    });

    const handleSelect: OnSelectFunction = async (selectedValues) => {
        setSelectedItens(selectedValues);
    };

    const handleSubmit = async (event: any) => {
        event.preventDefault();

        const itensPayload = [
            { id: 1 },
            { id: 2 }
        ];

        const payload = {
            nome,
            descricao,
            preco,
            quantidade_funcao: quantidadeFuncao,
            itens: itensPayload,
            duracao
        };

        let isValid = true;

        if (!nome) {
            setAlert({ message: 'Por favor, preencha o campo nome', variant: 'danger', show: true });
            isValid = false;
        }
        if (!descricao) {
            setAlert({ message: 'Por favor, preencha o campo descrição.', variant: 'danger', show: true });
            isValid = false;
        }
        if (!preco) {
            setAlert({ message: 'Por favor, preencha o campo preço.', variant: 'danger', show: true });
            isValid = false;
        }

        if (tipoProduto == 'Produto') {
            if (!quantidadeFuncao) {
                setAlert({ message: 'Por favor, preencha o campo quantidade de funções.', variant: 'danger', show: true });
                isValid = false;
            }

        } else {
            if (nome && descricao && preco) {
                isValid = true;
            }
        }


        try {
            if (isValid) {

                if (tipoProduto == 'Produto' || tipoProduto == 'Reaproveitamento') {
                    const payload = {
                        nome,
                        descricao,
                        preco,
                        quantidade_funcao: quantidadeFuncao,
                        itens: itensPayload,
                        duracao,
                        tipo: tipoProduto,
                        tipo_produto: profissionalSelecionado
                    };
                    await api.put(`produtos/editar/${idProduto}`, payload);
                    setAlert({ message: 'Produto editado com sucesso', variant: 'success', show: true });
                } else {
                    const payload = {
                        nome,
                        descricao,
                        preco,
                        quantidadeFuncao: quantidadeFuncao
                    };
                    await api.put(`adicionais/editar/${idProduto}`, payload);
                    setAlert({ message: 'Adicional editado com sucesso', variant: 'success', show: true });
                }

            }
        } catch (error) {
            console.error('Erro ao enviar dados do formulário:', error);
        }
    };

    const parseInputValue = (inputValue: string) => {
        const sanitizedValue = inputValue.replace(/[^0-9.,]/g, '');
        const normalizedValue = sanitizedValue.replace(/(\..*)\./g, '$1');
        return normalizedValue;
    };

    const handleSelectDuracao = (duracaoHoras: any) => {
        setDuracao(duracaoHoras);
    };

    const handleSelectType = (type: any) => {
        setProfissionalSelecionado(type);
    }

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Form onSubmit={handleSubmit}>
                    <h3>Informações Gerais</h3>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            {tipoProduto == 'Reaproveitamento' && (
                                <>
                                    <Label title='TIpo do Produto' htmlFor="nome" />
                                    <Select
                                        width="600px"
                                        id='empresas'
                                        onChange={(e: any) => handleSelectType(e.target.value)}
                                    >
                                        {tipoProfissional.map((tipo, index) => (
                                            <Options key={tipo.id} value={tipo.id} name={tipo.nome} selected={profissionalSelecionado ? profissionalSelecionado == tipo.id : index === 0} />
                                        ))}
                                    </Select>
                                </>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Nome' htmlFor="nome" />
                                <input
                                    type="text"
                                    id="nome"
                                    placeholder="Digite o Nome"
                                    value={nome}
                                    onChange={(e) => {
                                        setNome(e.target.value);
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label title='Descrição' htmlFor="descricao" />
                                <textarea
                                    id="descricao"
                                    placeholder="Digite a descrição"
                                    value={descricao}
                                    onChange={(e) => setDescricao(e.target.value)}
                                    style={{ width: '100%', minHeight: '100px' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    {tipoProduto == 'Produto' ? (
                        <>
                            <Row>
                                <Col xs={12} md={3} xl={3}>
                                    <FormGroup>
                                        <Label title='Preço' htmlFor="preco" />
                                        <input
                                            type="text"
                                            id="preco"
                                            placeholder="Escolha o preço do produto"
                                            value={preco}
                                            onChange={(e) => setPreco(parseInputValue(e.target.value))}
                                            style={{ width: '100%' }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={3}>
                                    <FormGroup>
                                        <Label title='Quantidade de Funções' htmlFor="quantidade_funcao" />
                                        <input
                                            type="number"
                                            id="quantidade_funcao"
                                            placeholder="digite a quantidade de funções"
                                            value={quantidadeFuncao}
                                            onChange={(e) => setQuantidadeFuncao(parseInt(e.target.value))}
                                            style={{ width: '100%' }} />

                                    </FormGroup>
                                </Col>
                            </Row>
                            <Button className="btn-main mt-4" type="submit">Salvar Produto</Button>
                        </>
                    ) : (
                        <>
                            <Row>
                                <Col xs={12} md={3} xl={3}>
                                    <FormGroup>
                                        <Label title='Preço' htmlFor="preco" />
                                        <input
                                            type="text"
                                            id="preco"
                                            placeholder="Escolha o preço do adicional"
                                            value={preco}
                                            onChange={(e) => setPreco(parseInputValue(e.target.value))}
                                            style={{ width: '100%' }} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={3}>
                                    <FormGroup>
                                        <Label title='Quantidade de Funções' htmlFor="quantidade_funcao" />
                                        <input
                                            type="number"
                                            id="quantidade_funcao"
                                            placeholder="digite a quantidade de funções"
                                            value={quantidadeFuncao}
                                            onChange={(e) => setQuantidadeFuncao(parseInt(e.target.value))}
                                            style={{ width: '100%' }} />

                                    </FormGroup>
                                </Col>
                            </Row>
                            <Button className="btn-main mt-4" type="submit">{tipoProduto == 'Reaproveitamento' ? 'Salvar Produto' : 'Salvar Adicional'}</Button>
                        </>
                    )}
                </Form>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div>
    );
}
